enum DataLayerEventsEnum {
  CfgInquiryFormSubmit = 'cfg_inquiry_form_submit',
  SrovIssuerLogout = 'srov_issuer_logout',
  SrovIssuerSignUpStart = 'srov_issuer_signup_start',
  SrovIssuerSignUpDone = 'srov_issuer_signup_done',
  SrovIssuerRegistrationDone = 'srov_issuer_registration_done',
  SrovIssuerFormPremiumSubmit = 'srov_issuer_form_premium_submit',
  SrovIssuerFormFreeSubmit = 'srov_issuer_form_free_submit',
}

export default DataLayerEventsEnum
